export default __webpack_public_path__ + "static/media/medical-icon.df0c5e79.svg";